/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
// apis
import {
  deleteRoles,
  getRole,
  getRoles,
  getRolesEmployees,
  getRolesPermissions,
  postRoles,
  updateRoles,
} from "../../../../apis/companies/roles";
// components
import Button from "../../../../components/Button";
import { ColCard } from "../../../../components/ContentLayout";
import ToggleSwitch from "../../../../components/ToggleSwitch";
import Icon from "../../../../components/Icon";
import Input from "../../../../components/Input";
import NoData from "../../../../components/NoData/NoData";
// icons
import RoleIcon from "../../../../assets/images/icon/role-icon.svg";
import arrowBoxIcon from "../../../../assets/images/icon/arrow-box-icon.svg";
import faceIcon from "../../../../assets/images/icon/face-icon.svg";
// utils
import { cloneDeep, every, findIndex, findLastIndex, flattenDeep, forEach, get, isEmpty, isEqual, isUndefined, remove } from "lodash";
import SVG from "react-inlinesvg";
import { classnames } from "../../../../utils/text";
import { toast } from "../../../../utils/toast";
import systemAlert from "../../../../utils/systemAlert";
import { viewLoading } from "../../../../utils/loading";
import RoleEmployeeModal from "./RoleEmployeeModal";
import { useDispatch } from "react-redux";
import { setProfile } from "../../../../store/profile/actions";

const Roles = ({ permission }) => {
  const dispatch = useDispatch()
  // 전체 업무 리스트
  const [roleList, setRoleList] = useState([]);
  const [originRoleList, setOriginRoleList] = useState([]);
  // 업무 선택
  const [selected, setSelected] = useState("0");
  // 선택된 업무
  const [selectedRole, setSelectedRole] = useState({});
  // 업무에 배정된 직원 리스트
  const [selectedRoleEmployees, setSelectedRoleEmployees] = useState([])
  // 선택된 업무의 권한 리스트
  const [permissions, setPermissions] = useState([]);
  // 페이지 모드
  const [mode, setMode] = useState('detail')
  // 수정 취소를 대비하여 기존 권한을 담아 둘 리스트
  const [originPermissions, setOriginPermissions] = useState([])
  const [roleName, setRoleName] = useState('')
  // 업무에 배정된 직원 관리 모달.
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (!isEmpty(roleList[selected])) {
      if (isUndefined(roleList[selected].idx)) return

      getRole(roleList[selected].idx).then((res) => {
        setSelectedRole(res.data.role);
      });

      getRolesEmployees(roleList[selected].idx).then((res) => {
        setSelectedRoleEmployees(res.data.employees)
      });
    }
  }, [selected, roleList]);

  useEffect(() => {
    getRoleList()
  }, [])

  useEffect(() => {
    submit();
  }, [selectedRole]);

  const handleRoleChange = (e) => {
    setSelected(e.target.value);

    if (mode === 'create') {
      handleCancleCreate()
    }

    if (mode === 'modify') {
      handleCancleUpdate()
    }
  };

  const getRoleList = () => {
    getRoles()
      .then((res) => {
        setRoleList(res.data.roles);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const submit = () => {
    const permissionList = [
      { menuName: "담당자 상담", list: [], isOpen: true },
      { menuName: "할일", list: [], isOpen: true },
      { menuName: "커뮤니티", list: [], isOpen: true },
      { menuName: "출퇴근", list: [], isOpen: true },
      { menuName: "근무일정", list: [], isOpen: true },
      { menuName: "휴가", list: [], isOpen: true },
      { menuName: "급여", list: [], isOpen: true },
      { menuName: "사람", list: [], isOpen: true },
      { menuName: "전자계약", list: [], isOpen: true },
      { menuName: "자금", list: [], isOpen: true },
      { menuName: "전자계산서", list: [], isOpen: true },
      { menuName: "경비청구", list: [], isOpen: true },
      { menuName: "업로드 내역", list: [], isOpen: true },
      { menuName: "파일 보관함", list: [], isOpen: true },
      { menuName: "관리자", list: [], isOpen: true },
      { menuName: "품목", list: [], isOpen: true },
      { menuName: "거래처", list: [], isOpen: true },
      { menuName: "기타", list: [], isOpen: true },
    ];

    getRolesPermissions().then((res) => {
      forEach(res.data.permissions, (allPermission) => {
        switch (allPermission.code) {
          case "TAX_COUNSELING": //세무 상담
          case "LABOR_COUNSELING": //노무 상담
            let count0 = 0
            forEach(selectedRole.permissions, (permission) => {
              if (allPermission.code === permission.code) {
                permissionList[0].list.push({ ...allPermission, ...permission })
                count0++
              }
            })
            if (count0 === 0) {
              permissionList[0].list.push({ ...allPermission, level: 0 });
            }
            break;
          case "TODO": //할일
            let count = 0
            forEach(selectedRole.permissions, (permission) => {
              if (allPermission.code === permission.code) {
                permissionList[1].list.push({ ...allPermission, ...permission })
                count++
              }
            })
            if (count === 0) {
              permissionList[1].list.push({ ...allPermission, level: 0 });
            }
            break;
          case "COMMUNITY": //커뮤니티
            let comuunityCount = 0
            forEach(selectedRole.permissions, (permission) => {
              if (allPermission.code === permission.code) {
                permissionList[2].list.push({ ...allPermission, ...permission })
                comuunityCount++
              }
            })
            if (comuunityCount === 0) {
              permissionList[2].list.push({ ...allPermission, level: 0 });
            }
            break;
          case "COMMUTE_HISTORY": // 나의 출퇴근 기록
          case "COMMUTE_MANAGEMENT": // 출퇴근 관리
          case "WORK_TIME_MANAGEMENT": // 근로시간 관리
          case "WORK_HISTORY": // 부서별 근무 현황
          case "WORK_PLACE_MANAGEMENT": // 출퇴근 장소 관리
            let count1 = 0
            forEach(selectedRole.permissions, (permission) => {
              if (allPermission.code === permission.code) {
                permissionList[3].list.push({ ...allPermission, ...permission })
                count1++
              }
            })
            if (count1 === 0) {
              permissionList[3].list.push({ ...allPermission, level: 0 });
            }
            break;
          case "WORK_SCHEDULE_MANAGEMENT": // 근무 일정 관리
          case "HOLIDAY": // 공통 휴일
          case "OTHER_WORK_MANAGEMENT": // 기타 근무 항목 설정
            let count2 = 0
            forEach(selectedRole.permissions, (permission) => {
              if (allPermission.code === permission.code) {
                permissionList[4].list.push({ ...allPermission, ...permission })
                count2++
              }
            })
            if (count2 === 0) {
              permissionList[4].list.push({ ...allPermission, level: 0 });
            }
            break;
          case "VACATION_PLAN": // 휴가 실적 및 계획
          case "ADDED_VACATION_HISTORY": // 휴가 부여 현황
          case "VACATION_LEAVE_MANAGEMENT": // 연차 기준 관리
          case "OTHER_VACATION_MANAGEMENT": // 기타 휴가 관리
            let count3 = 0
            forEach(selectedRole.permissions, (permission) => {
              if (allPermission.code === permission.code) {
                permissionList[5].list.push({ ...allPermission, ...permission })
                count3++
              }
            })
            if (count3 === 0) {
              permissionList[5].list.push({ ...allPermission, level: 0 });
            }
            break;
          case "SALARY": // 나의 급여 조회
          case "SALARY_HISTORY_MANAGEMENT": // 급여 내역 관리
          case "SALARY_ITEM_MANAGEMENT": // 급여 항목 관리
            let count4 = 0
            forEach(selectedRole.permissions, (permission) => {
              if (allPermission.code === permission.code) {
                permissionList[6].list.push({ ...allPermission, ...permission })
                count4++
              }
            })
            if (count4 === 0) {
              permissionList[6].list.push({ ...allPermission, level: 0 });
            }
            break;
          case "USER": // 사람
            let count5 = 0
            forEach(selectedRole.permissions, (permission) => {
              if (allPermission.code === permission.code) {
                permissionList[7].list.push({ ...allPermission, ...permission })
                count5++
              }
            })
            if (count5 === 0) {
              permissionList[7].list.push({ ...allPermission, level: 0 });
            }
            break;
          case "CONTRACT": // 전자계약
            let count6 = 0
            forEach(selectedRole.permissions, (permission) => {
              if (allPermission.code === permission.code) {
                permissionList[8].list.push({ ...allPermission, ...permission })
                count6++
              }
            })
            if (count6 === 0) {
              permissionList[8].list.push({ ...allPermission, level: 0 });
            }
            break;
          case "FUND_REPORT": //리포트
          case "FUND_JOURNAL": //자금일보
          case "FUND_BANK_HISTORY": // 은행 입출금 내역
          case "FUND_CARD_HISTORY": // 신용카드 내역
          case "FUND_CLAIM_OBLIGATION": // 거래처별 채권채무
            let count7 = 0
            forEach(selectedRole.permissions, (permission) => {
              if (allPermission.code === permission.code) {
                permissionList[9].list.push({ ...allPermission, ...permission })
                count7++
              }
            })
            if (count7 === 0) {
              permissionList[9].list.push({ ...allPermission, level: 0 });
            }
            break;
          case "TRADE_INVOICE": // 거래명세서
          case "TAX_INVOICE": // 전자 계산서
          case "CASH_INVOICE": // 현금영수증
            let count8 = 0
            forEach(selectedRole.permissions, (permission) => {
              if (allPermission.code === permission.code) {
                permissionList[10].list.push({ ...allPermission, ...permission })
                count8++
              }
            })
            if (count8 === 0) {
              permissionList[10].list.push({ ...allPermission, level: 0 });
            }
            break;
          case "EXPENSE": // 경비청구
            let count9 = 0
            forEach(selectedRole.permissions, (permission) => {
              if (allPermission.code === permission.code) {
                permissionList[11].list.push({ ...allPermission, ...permission })
                count9++
              }
            })
            if (count9 === 0) {
              permissionList[11].list.push({ ...allPermission, level: 0 });
            }
            break;
          case "UPLOAD_HISTORY": // 업로드 내역
            let count10 = 0
            forEach(selectedRole.permissions, (permission) => {
              if (allPermission.code === permission.code) {
                permissionList[12].list.push({ ...allPermission, ...permission })
                count10++
              }
            })
            if (count10 === 0) {
              permissionList[12].list.push({ ...allPermission, level: 0 });
            }
            break;
          case "FILES": // 파일보관함
            let filesCount = 0
            forEach(selectedRole.permissions, (permission) => {
              if (allPermission.code === permission.code) {
                permissionList[13].list.push({ ...allPermission, ...permission })
                filesCount++
              }
            })
            if (filesCount === 0) {
              permissionList[13].list.push({ ...allPermission, level: 0 });
            }
            break;
          case "COMPANY_MANAGEMENT": // 회사 정보 관리
          case "WORK_MANAGER_MANAGEMENT": // 업무 담당자 관리
          case "OUTSIDE_MANAGER_MANAGEMENT": // 외부 담당자 관리
          case "FINANCE_SCRAPING": // 금융 정보 자동 수집
          case "COMPANY_PLACE_MANAGEMENT": // 사업장 정보 관리
            let count11 = 0
            forEach(selectedRole.permissions, (permission) => {
              if (allPermission.code === permission.code) {
                permissionList[14].list.push({ ...allPermission, ...permission })
                count11++
              }
            })
            if (count11 === 0) {
              permissionList[14].list.push({ ...allPermission, level: 0 });
            }
            break;
          case "PRODUCT": // 품목
            let count12 = 0
            forEach(selectedRole.permissions, (permission) => {
              if (allPermission.code === permission.code) {
                permissionList[15].list.push({ ...allPermission, ...permission })
                count12++
              }
            })
            if (count12 === 0) {
              permissionList[15].list.push({ ...allPermission, level: 0 });
            }
            break;
          case "COMPANY_ACCOUNT": // 거래처
            let count13 = 0
            forEach(selectedRole.permissions, (permission) => {
              if (allPermission.code === permission.code) {
                permissionList[16].list.push({ ...allPermission, ...permission })
                count13++
              }
            })
            if (count13 === 0) {
              permissionList[16].list.push({ ...allPermission, level: 0 });
            }
            break;
          case "NOTIFICATION": // 알림
          case "NOTICE": // 공지사항
            let count14 = 0
            forEach(selectedRole.permissions, (permission) => {
              if (allPermission.code === permission.code) {
                permissionList[17].list.push({ ...allPermission, ...permission })
                count14++
              }
            })
            if (count14 === 0) {
              permissionList[17].list.push({ ...allPermission, level: 0 });
            }
            break;
          default:
            break;
        }
      });

      setPermissions(permissionList);
    });
  };

  // 권한 변경
  const handlePermissionChange = (e, data) => {
    if (selectedRole.type === 1) return toast.error('회사 대표의 권한은 수정이 불가합니다.')
    const { checked, name } = e.target

    switch (name.includes('read')) {
      case true:
        if (checked) {
          let newPermissions = [...permissions]
          forEach(newPermissions, (newPermission) => {
            if (newPermission.list.includes(data)) {
              const idx = findIndex(newPermission.list, (li) => li.code === data.code)
              let transPermission = [...newPermission.list]
              transPermission[idx] = {
                ...data,
                level: 1,
              }

              newPermission.list = transPermission
            }
          })
          setPermissions(newPermissions)
        } else {
          let newPermissions = [...permissions]
          forEach(newPermissions, (newPermission) => {
            if (newPermission.list.includes(data)) {
              const idx = findIndex(newPermission.list, (li) => li.code === data.code)
              let transPermission = [...newPermission.list]
              transPermission[idx] = {
                ...data,
                level: 0,
              }

              newPermission.list = transPermission
            }
          })
          setPermissions(newPermissions)
        }
        break;
      case false:
        if (checked) {
          let newPermissions = [...permissions]
          forEach(newPermissions, (newPermission) => {
            if (newPermission.list.includes(data)) {
              const idx = findIndex(newPermission.list, (li) => li.code === data.code)
              let transPermission = [...newPermission.list]
              transPermission[idx] = {
                ...data,
                level: 2,
              }

              newPermission.list = transPermission
            }
          })
          setPermissions(newPermissions)
        } else {
          let newPermissions = [...permissions]
          forEach(newPermissions, (newPermission) => {
            if (newPermission.list.includes(data)) {
              const idx = findIndex(newPermission.list, (li) => li.code === data.code)
              let transPermission = [...newPermission.list]
              transPermission[idx] = {
                ...data,
                level: 1,
              }

              newPermission.list = transPermission
            }
          })
          setPermissions(newPermissions)
        }
        break;
      default:
        break;
    }
  };

  // 메뉴 별 권한 전체 변경
  const handlePermissionAllChange = (e, data) => {
    if (selectedRole.type === 1) return toast.error('회사 대표의 권한은 수정이 불가합니다.')
    const { checked, name } = e.target

    switch (name.includes('read')) {
      case true:
        if (checked) {
          let newPermissions = [...permissions]
          const idx = findIndex(newPermissions, (list) => list.menuName === data.menuName)
          newPermissions[idx].list = newPermissions[idx].list.map((permission) => ({
            ...permission,
            level: 1
          }))
          setPermissions(newPermissions)
        } else {
          let newPermissions = [...permissions]
          const idx = findIndex(newPermissions, (list) => list.menuName === data.menuName)
          newPermissions[idx].list = newPermissions[idx].list.map((permission) => ({
            ...permission,
            level: 0
          }))
          setPermissions(newPermissions)
        }
        break;
      case false:
        if (checked) {
          let newPermissions = [...permissions]
          const idx = findIndex(newPermissions, (list) => list.menuName === data.menuName)
          newPermissions[idx].list = newPermissions[idx].list.map((permission) => ({
            ...permission,
            level: 2
          }))
          setPermissions(newPermissions)
        } else {
          let newPermissions = [...permissions]
          const idx = findIndex(newPermissions, (list) => list.menuName === data.menuName)
          newPermissions[idx].list = newPermissions[idx].list.map((permission) => ({
            ...permission,
            level: 1
          }))
          setPermissions(newPermissions)
        }
        break;
      default:
        break;
    }
  }

  // 업무 추가
  const handleCreateRoles = () => {
    let body = {
      roleName,
      permissions: flattenDeep(permissions.map((p) => p.list.map((l) => ({ code: l.code, level: l.level }))))
    }
    remove(body.permissions, n => n.level === 0)

    // if (isEmpty(body.permissions)) return toast.error('권한을 체크해주세요.')
    viewLoading(true)
    postRoles(body).then((res) => { getRoleList(); handleModeChange('detail'); }).catch(() => { }).finally(() => viewLoading(false))
  }

  // 업무 삭제
  const handleRemoveRole = () => {
    systemAlert(
      '해당 업무를 삭제하시겠습니까 ?', {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '삭제',
          onClick: () => {
            viewLoading(true)
            deleteRoles(selectedRole.idx).then(() => { getRoleList(); setSelected("0") }).catch(() => { }).finally(() => viewLoading(false))
          }
        }
      ]
    })
  }

  // 업무 수정
  const handleUpdateRoles = () => {
    let body = {
      roleName,
      permissions: flattenDeep(permissions.map((p) => p.list.map((l) => ({ code: l.code, level: l.level }))))
    }
    remove(body.permissions, n => n.level === 0)

    viewLoading(true)
    updateRoles(selectedRole.idx, body).then((res) => { getRoleList(); handleModeChange('detail'); dispatch(setProfile()) }).catch(() => { }).finally(() => viewLoading(false))
  }

  // 수정 취소
  const handleCancleUpdate = () => {
    handleModeChange('detail')
    setPermissions(originPermissions)
    setOriginPermissions([])
    setRoleName('')
  }

  // 등록 취소
  const handleCancleCreate = () => {
    handleModeChange('detail')
    setRoleList(originRoleList)
    setSelected("0")
  }

  // 모드 체인지
  const handleModeChange = (mode) => {
    setMode(mode)

    if (mode === 'create') {
      // 등록일 경우
      const _roleList = cloneDeep(roleList)
      setOriginRoleList(_roleList)
      setRoleList(oldVal => [...oldVal, { roleName: '새 업무' }])
      setSelected(`${findLastIndex(roleList) + 1}`)
      setSelectedRole('create')
      setPermissions(oldVal => [...oldVal.map((menu) => ({ ...menu, list: menu.list.map((permission) => ({ ...permission, level: 0 })) }))])
      setOriginPermissions([...permissions.map((menu) => ({ ...menu, list: menu.list.map((permission) => ({ ...permission, level: 0 })) }))])
    }

    if (mode === 'modify') {
      // 수정일 경우
      const _permissions = cloneDeep(permissions)
      setOriginPermissions(_permissions)
      setRoleName(selectedRole.roleName)
    }
  }

  // 변경저장 disabled
  const getDisabled = (mode) => {
    let disabled = true;
    const _originPermissions = []
    const _permissions = []
    forEach(originPermissions, (origin) => {
      _originPermissions.push(origin.list.map((li) => ({ name: li.name, code: li.code, level: li.level })))
    })
    forEach(permissions, (permission) => {
      _permissions.push(permission.list.map((li) => ({ name: li.name, code: li.code, level: li.level })))
    })
    switch (mode) {
      case 'create':
        if (!isEqual(_originPermissions, _permissions) || !isEmpty(roleName)) disabled = false
        break;
      case 'modify':
        if (!isEqual(_originPermissions, _permissions) || !isEqual(selectedRole.roleName, roleName)) disabled = false
        break;
      default:
        break;
    }

    return disabled
  }

  const getEmployeeInfo = () => {
    if (permission.level <= 1) return;
    setOpen(true)
  }

  const getAllChecked = (type, data) => {
    let checked = false;

    switch (type) {
      case 'read':
        checked = every(data.list, (data) => data.level > 0)
        break;
      case 'update':
        checked = every(data.list, (data) => data.level > 1)
        break;
      default:
        break;
    }

    return checked
  }

  return (
    <>
      <div className="roles-write">
        <ColCard cardBody={{ className: "p-0" }}>
          <div className="role-list">
            <div className="role-list-header">
              <label className="role-list-title">업무 리스트</label>
              {permission && permission.level > 1 && ((mode === 'detail') || (mode === 'modify')) && (<Button
                className="float-right"
                color="line"
                size="sm"
                label="새 업무 추가"
                action={() => handleModeChange('create')}
              />)}
              {permission && permission.level > 1 && mode === 'create' && (<Button
                className="float-right"
                color="gray-line"
                size="sm"
                label="새 업무 취소"
                action={handleCancleCreate}
              />)}
            </div>
            <div className="role-list-body">
              {isEmpty(roleList) ? (
                <NoData />
              ) : (
                roleList.map((role, idx) => (
                  <React.Fragment key={idx}>
                    <input
                      id={`select-role-${idx}`}
                      type="radio"
                      name="roles-radio"
                      className="roles-radio"
                      value={idx}
                      checked={selected === String(idx)}
                      onChange={handleRoleChange}
                    />
                    <label
                      htmlFor={`select-role-${idx}`}
                      className="role-list-wrap"
                    >
                      <Icon className="role-icon" src={RoleIcon} />
                      <span className="role-name">{role.roleName}</span>
                    </label>
                  </React.Fragment>
                ))
              )}
            </div>
          </div>
          <div className="permission-list">
            {isEmpty(selectedRole) ? (
              <NoData />
            ) : (
              <>
                <div className="permission-header">
                  <Icon className="role-icon" src={RoleIcon} />
                  {mode === 'detail' && (
                    <span className="selected-role-name">
                      {selectedRole.roleName}
                    </span>
                  )}
                  {((mode === 'modify') || (mode === 'create')) && (
                    <Input className="role-name-input" value={roleName} placeholder="담당업무 이름 입력" onChange={(e) => setRoleName(e.target.value)} />
                  )}
                  <div className="header-button-wrap">
                    {permission.level > 1 && mode === 'detail' && (
                      <>
                        {!(get(selectedRole, 'type') === 1 || get(selectedRole, 'type') === 2 || get(selectedRole, 'type') === 5) && (<Button label="삭제" color="gray-line" size="sm" className="margin-right-8" onClick={handleRemoveRole} />)}
                        <Button label="수정하기" color="line" size="sm" onClick={() => handleModeChange('modify')} />
                      </>
                    )}
                    {mode === 'create' && (
                      <Button label="완료" size="sm" onClick={handleCreateRoles} disabled={getDisabled('create')} />
                    )}
                    {mode === 'modify' && (
                      <>
                        <Button label="취소" color="gray-line" size="sm" className="margin-right-8" onClick={handleCancleUpdate} />
                        <Button label="변경저장" size="sm" onClick={handleUpdateRoles} disabled={getDisabled('modify')} />
                      </>
                    )}
                  </div>
                </div>
                {mode !== 'create' && (
                  <div className="employee-info-container">
                    <div className="employee-info-wrap" onClick={getEmployeeInfo}>
                      <Icon className="employee-face-icon" src={faceIcon} />
                      {isEmpty(selectedRoleEmployees) ? (<span className="employee-name">업무에 배정된 직원이 없습니다.</span>) : (
                        <span className="employee-name">
                          {selectedRoleEmployees.map(employee => { return employee.name }).join(", ")}
                        </span>
                      )}
                    </div>
                  </div>
                )}
                <div className="permission-body">
                  {!isEmpty(permissions) &&
                    permissions.map((permission, idx) => (
                      <div className="permission-menu-wrap" key={idx}>
                        <div className="permission-menu-title">
                          <Button
                            className={classnames("toggle-button p-0", {
                              closed: !permission.isOpen,
                            })}
                            color="text"
                            size="x-sm"
                            label={<SVG src={arrowBoxIcon} />}
                            onClick={() => {
                              let newArray = [...permissions];
                              newArray[idx] = {
                                ...newArray[idx],
                                isOpen: !newArray[idx].isOpen,
                              };
                              setPermissions(newArray);
                            }}
                          />
                          <label className="menu-name">{permission.menuName}</label>
                          <ToggleSwitch
                            className="margin-left-16"
                            name={`read-all-${idx}`}
                            label="조회"
                            disabled={mode === 'detail'}
                            checked={getAllChecked('read', permission)}
                            onChange={handlePermissionAllChange}
                            data={permission}
                          />
                          <ToggleSwitch
                            className="margin-left-16"
                            name={`update-all-${idx}`}
                            label="편집"
                            disabled={mode === 'detail'}
                            checked={getAllChecked('update', permission)}
                            onChange={handlePermissionAllChange}
                            data={permission}
                          />
                        </div>
                        {permission.isOpen && (
                          <div className="permission-menu">
                            {permission.list.map((allPermission, index) => (
                              <div key={index} className="permission-wrap">
                                <label className="permission-label">
                                  {allPermission.name}
                                </label>
                                <ToggleSwitch
                                  className="margin-left-16"
                                  name={`read-${idx}-${index}`}
                                  label="조회"
                                  disabled={mode === 'detail'}
                                  checked={allPermission.level > 0}
                                  onChange={handlePermissionChange}
                                  data={allPermission}
                                />
                                <ToggleSwitch
                                  className="margin-left-16"
                                  name={`update-${idx}-${index}`}
                                  label="편집"
                                  disabled={mode === 'detail'}
                                  checked={allPermission.level > 1}
                                  onChange={handlePermissionChange}
                                  data={allPermission}
                                />
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                </div>
              </>
            )}
          </div>
        </ColCard>
      </div>
      <RoleEmployeeModal
        open={open}
        setOpen={setOpen}
        employeeList={selectedRoleEmployees}
        role={selectedRole}
        submit={getRoleList}
      />
    </>
  );
};

export default Roles;

// 0 : 권한없음 , 1 : 조회 , 2 : 편집
// 정보 자체가없으면 권한 없음
